type PutFileOptions = {
  attempts?: number;
  delayMs?: number;
};

const delay = (delayMs: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, delayMs);
  });

const attemptPut = (
  url: string,
  body: BodyInit,
  attemptsLeft: number,
  delayMs: number,
): Promise<Response> =>
  fetch(url, { method: "PUT", body }).catch((error: unknown) => {
    if (attemptsLeft <= 1) throw error;
    const retry = () => attemptPut(url, body, attemptsLeft - 1, delayMs);
    return delayMs > 0 ? delay(delayMs).then(retry) : retry();
  });

/** PUT a file, retrying a rejected fetch. A network blip otherwise becomes an unhandled rejection. */
export const putFile = (
  url: string,
  body: BodyInit,
  { attempts = 3, delayMs = 250 }: PutFileOptions = {},
): Promise<Response> => attemptPut(url, body, attempts, delayMs);
